var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "responsive-image bg-gray-150",
    class: {
      'responsive-image--zoomed': _vm.zoom
    }
  }, [_c('aspect-ratio-box', {
    attrs: {
      "ratio": _vm.currentDimensions.ratio
    }
  }, [_c('div', {
    ref: "image",
    staticClass: "responsive-img",
    class: {
      'loading': _vm.isLoading
    },
    style: _vm.imageStyle,
    attrs: {
      "role": "img",
      "aria-label": _vm.alt,
      "data-background-image-set": _vm.immediate ? null : _vm.imageSrcSet,
      "data-background-image": _vm.immediate || _vm.imageSrcSet ? null : _vm.imageSrc
    }
  }), _vm._v(" "), _vm.gradient ? _c('div', {
    staticClass: "absolute left-0 top-0 w-full h-full",
    style: _vm.gradientStyle
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }